module.exports = __webpack_public_path__ + "static/ph-album-art-9752fa0c858c64af08e3773978538491.jpg";